unicodeSize